<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des Gammes Produit</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
          </div>
          <div slot="libelle" slot-scope="props">
            {{ props.row.libelle }} ( {{ props.row.secteur.toUpperCase().replaceAll(',', ' | ') }} )
          </div>
          <div slot="action" slot-scope="props">
            <b-button v-if="canManageGammeProduit()" type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i
              class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button v-if="canManageGammeProduit()" type="button" @click="edit(props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>

      <div slot="footer">
        <b-button v-if="canManageGammeProduit()" type="button" @click="add" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une gamme produit
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { formatDate } from "@/utils/communHelper"
import { hasRule, espaceGestionRules as rules } from '@/utils/rulesHelper'

export default {
  name: "List",
  data() {
    return {
      columns: ['created_at', 'libelle', 'remarque', 'action'],
      data: [],
      options: {
        headings: {
          'created_at': 'Date de création',
          'libelle': 'Libellé',
          'remarque': 'Remarque'
        },
        columnsClasses: {
          action: 'action-md',
        },
        sortable: ['created_at'],
        filterable: ['libelle'],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Libellé"
        },
        orderBy: {column: 'created_at', ascending: false}
      },
      formatDate,
    }
  },
  mounted() {
    this.all()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    all() {
      this.$axios
        .get("/espaceGestion/produit/gestion-gamme")
        .then(response => {
          this.data = response.data.gammesProduit
        })
        .catch(() => {
          this.$store.commit("IS_LOADING", false)
          this.handleError()
        });
    },
    canManageGammeProduit() {
      return hasRule(rules.CAN_MANAGE_PRODUIT)
    },
    destroy(id) {
      this.$swal
        .fire({
          title: 'Êtes-vous sûr?',
          text: "Voulez-vous vraiment supprimer cette gamme produit ?",
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        })
        .then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .delete("/espaceGestion/produit/gestion-gamme/delete/" + id)
              .then(() => {
                this.$store.commit('IS_LOADING', false)
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Suppression avec succès',
                  text: "La gamme produit a bien été supprimée",
                  showConfirmButton: false,
                  timer: 5000
                });
                this.all();
              })
              .catch((error) => {
                this.$store.commit("IS_LOADING", false);
                if (error.response.status == 401) {
                  this.$swal({
                    position: 'top',
                    type: 'warning',
                    title: 'Attention !!',
                    text: "La suppression est impossible, il existe encore des familles associées à cette gamme de produit.",
                    showConfirmButton: false,
                    timer: 5000
                  });
                } else {
                  this.handleError();
                }
              })
          }
        })

    },
    add() {
      this.$router.push({path: '/espace-gestion/produit/gestion-gamme/add'})
    },
    edit(id) {
      this.$router.push({path: '/espace-gestion/produit/gestion-gamme/edit/' + id})
    },
    handleError() {
      this.$swal({
        position: 'top',
        type: 'error',
        title: 'Attention !!',
        text: 'Un problème est survenu, merci de contacter l\'administrateur',
        showConfirmButton: false,
        timer: 5000
      });
    }
  }
}
</script>

<style scoped>

</style>